module.exports = __webpack_public_path__ + "img/81.23d27b5d.jpg";